"use client";

import Image from "next/image";
import { useSearchParams } from "next/navigation";
import { useEffect } from "react";
import Flex from "~/components/flex/Flex";
import { SEARCH_PARAM_REGISTRATION_MODAL } from "~/constants";
import { updateSearchParams } from "~/utils/clientUtils";

/**
 * Register Page
 *
 * This page opens the registration modal via query parameter.
 * The actual registration form is displayed in the RegistrationModal component
 * which is managed by DisplayModals.
 */
const RegisterPage = () => {
  const searchParams = useSearchParams();

  useEffect(() => {
    // Ensure registration modal query parameter is set
    const currentParam = searchParams.get(SEARCH_PARAM_REGISTRATION_MODAL);
    if (currentParam !== "true") {
      const params = new URLSearchParams(searchParams.toString());
      params.set(SEARCH_PARAM_REGISTRATION_MODAL, "true");
      updateSearchParams(params);
    }
  }, [searchParams]);

  return (
    <Flex className="fixed inset-0 w-full h-full overflow-hidden">
      <Image
        className="w-full h-full object-cover blur-sm scale-101"
        src="/images/supplier-app.webp"
        alt="Registration background"
        fill
        priority
        quality={85}
        style={{ objectFit: "cover" }}
      />
    </Flex>
  );
};

export default RegisterPage;
